<template>
  <popper trigger="hover" :options="{placement: 'left'}">
    <div class="popper" v-if='liveListing.priceInfoHistories.length > 0'>
        <table>
          <thead>
              <tr>
                <th>id</th>
                <th>Datum</th>
                <th>Seller</th>
                <th>FBA</th>
                <th>PS</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for='(pri, priIndex) in liveListing.priceInfoHistories' :key="priIndex">
                <td>{{pri.historyId}}</td>
                <!--td>{{pri.lastUpdateTime.replace(/-/g,'.')}}</td-->
                <td>{{pri.lastUpdateTime}}
                  <span>
                    {{pri.lastUpdateTime.substring(8,10) + '.' +
                    pri.lastUpdateTime.substring(5,7) + '.' +
                    pri.lastUpdateTime.substring(0,4) + ' ' +
                    pri.lastUpdateTime.substring(11,13) + ':' +
                    pri.lastUpdateTime.substring(14,16)
                    }}

                    </span></td>
                <td v-if='pri.merchantPrice != null'>{{Number(pri.merchantPrice).toFixed(2)}}</td><td v-else>—</td>
                <td v-if='pri.marketPrice != null'>{{Number(pri.marketPrice).toFixed(2)}}</td><td v-else>—</td>
                <td>{{pri.priceState}}</td>
              </tr>
          </tbody>
        </table>
    </div>
    <div class="popper" v-else>
        <span class="m-2">leer</span>
    </div>
    <p href="#" slot="reference" class="top">
        {{liveListing.priceState}}
    </p>
  </popper>
</template>

<script>

export default {
  props : {
    liveListing: {
      type : Object,
      requiered: true,
    }
  }
}
</script>
